import { Wrapper } from './Styled'

interface InfoProps {
  id?: any
  style?: React.CSSProperties
  message?: React.ReactNode
  options?: {
    rotation?: number
    [key: string]: any
  }
  close?: () => void
}

export default function Info({ id, style, message, options, close }: InfoProps) {
  const rotation = isFinite(options?.rotation ?? NaN) ? options?.rotation ?? 0 : 0
  const wrapStyle = {
    transform: `rotate(${rotation}deg)`,
  }
  return <Wrapper style={wrapStyle}>{message}</Wrapper>
}
